import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import { useAccess } from "../services/auth/AccessProvider";

const NoAccess = () => {
  const { profile } = useAccess();
  const roleName = profile?.role || "this role";

  return (
    <AdminLayout>
      <section className="px-5 py-16 md:px-8">
        <h1 className="text-xl font-bold text-[#111827] sm:text-2xl">
          No sections available
        </h1>
        <p className="mt-3 max-w-xl text-sm text-[#6B7280] sm:text-base">
          {roleName} is signed in, but it does not have permission for any
          admin sections yet. Ask an admin to update this role.
        </p>
      </section>
    </AdminLayout>
  );
};

export default NoAccess;
